module.exports = __webpack_public_path__ + "static/media/image05.88c1ca03.png";